module.exports = {
  RETAIL: 'retail',
  CONSUMABLES: 'consumables'
}
